import React from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { withRouter } from 'react-router-dom';
import { setTemp } from '@store/actions';
import { Button, Stack, Text, useResponsiveBreakpoints } from 'shared-components';
import { Helmet } from 'react-helmet';
import { PlaidConnectCardContainer } from './PlaidConnectCard';
import { SkipConnectCard } from './SkipConnectCard';
import { LoanWizardShell, getLoanPhaseIndex, getLoanFaqForRoute } from '@components/Apply/WizardShell';
import { useApplyWizardContext } from '../../../context/ApplyWizardContext';

const BankConnect = ({
  loan_id,
  loan_amount,
  first,
  vendor_name,
  dataLayerPush,
  setTemp,
  history,
  match,
  user,
  nextRoute,
  ...other
}) => {
  const responsiveBreakpoints = useResponsiveBreakpoints();
  const { currentPath } = useApplyWizardContext();
  const phase = getLoanPhaseIndex(currentPath);
  const faq = getLoanFaqForRoute(currentPath);

  return (
    <LoanWizardShell currentStepIndex={phase} wide faq={faq}>
      <Helmet>
        <title>Connect Bank Account - Your Loan Application</title>
      </Helmet>

      <div className="flex flex-col items-center w-full pt-[10px]">
        <Text variant="headline-sm" className="!font-extended !uppercase !text-[16px] !leading-none text-center">
          Connect Your Bank Account
        </Text>
        <div className="pt-[10px] max-w-[592px] text-center">
          <Text variant="body-general" className="!text-[16px] !leading-[24px] text-center">
            To be able to give you the quickest pre-qualification, we&apos;ll need the last 4 months of bank statements
            from your business.
          </Text>
        </div>
      </div>

      <div className="w-full pt-[20px]">
        <Stack flow="column" gapPx="10px">
          <Stack alignItems="start" justifyContent={responsiveBreakpoints.isDesktop ? 'end' : 'center'}>
            <PlaidConnectCardContainer
              {...{
                loan_id,
                loan_amount,
                first,
                vendor_name,
                dataLayerPush,
                setTemp,
                history,
                match,
                user,
                nextRoute,
                section: 'bank_connect',
                ...other,
              }}
            />
          </Stack>
          {responsiveBreakpoints.isDesktop && (
            <Stack alignItems="start" justifyItems="start" justifyContent="start" className="relative">
              <div>
                <Button
                  variant="cta-small-primary"
                  className="absolute top-[140px] left-[-30px] p-0 w-[50px] h-[50px] z-10 font-condensed hover:bg-spark pointer-events-none"
                  disabled
                >
                  OR
                </Button>
              </div>
              <SkipConnectCard
                nextRoute={nextRoute}
                match={match}
                loan_id={loan_id}
                first={first}
                dataLayerPush={dataLayerPush}
                history={history}
              />
            </Stack>
          )}
        </Stack>
      </div>
    </LoanWizardShell>
  );
};

const selector = formValueSelector('application');

const mapStateToProps = (state) => {
  return {
    first: selector(state, 'owner_1_first'),
    loan_id: selector(state, 'loan_id'),
    loan_amount: selector(state, 'loan_amount'),
    theme: state.theme,
    user: state.user,
    vendor_name: state.brand?.data?.vendor_name,
    business_id: selector(state, 'business_id'),
    contact_id: selector(state, 'owner_1_id'),
    mobile: selector(state, 'owner_1_mobile'),
    email: selector(state, 'owner_1_email'),
  };
};
export const BankConnectContainer = connect(mapStateToProps, { setTemp })(withRouter(BankConnect));
